import React, { useState, useEffect } from "react";
import { Grid, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import firebase from "../../firebase.js";
import useStyles from "./styles";
import "react-toastify/dist/ReactToastify.css";
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Typography } from "../../components/Wrappers/Wrappers";
import { LabelList, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import EngineBioTable from "./EngineBioTable";


var database = firebase.database();

export default function NotificationsPage(props) {
  const classes = useStyles();
  const [value, setValue] = useState("LMEZ411735     ");
  const [optionsState, setOptionsState] = useState([]);
  const [timelineData, setTimelineData] = useState([]);
  const [engineNumber, setEngineNumber] = useState("LMEZ411735     ");
  const [engineModel, setEngineModel] = useState("");
  const [crosshairValues, setCrosshairValues] = useState([]);
  const [LDState, setLDDataState] = useState([]);
  const [OTState, setOTDataState] = useState([]);
  const [numberState, setNumberState] = useState("");
  const [modelState, setModelState] = useState("");
  const [dataState, setDataState] = useState({
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
  });
  const [zoneState, setZoneDataState] = useState([]);
  const [lengthState, setLengthState] = useState(0);
  
  function createData(zone, stncode, opcode, timestamp, remarks) {
    return { zone, stncode, opcode, timestamp, remarks };
  }
  

  useEffect(() => {
    const ref2 = database.ref("ENS5/Engine Data");
    ref2.on("value", (snapshot) => {
      const options = [];
      snapshot.forEach(function (childSnapshot) {
        options.push(childSnapshot.key);
      });
      setOptionsState(options);
    });
    const ref = database.ref(`ENS5/Engine Data/${value}`);
    ref.on("value", (snapshot) => {
      const events = [];
      const zones = [];
      const LDData = [];
      const OTData = [];
      const Data = {};

      // Get Engine Number and Model
      setEngineNumber(value);
      setEngineModel(snapshot.child("Engine Model").val());

      snapshot.child("zone").forEach((zoneSnapshot) => {
        const zoneName = zoneSnapshot.key;
        const array = [];
        zones.push(zoneName);
        LDData.push(zoneSnapshot.child("Laydown Time").val());
        OTData.push(zoneSnapshot.child("Offtrack Time").val());

        events.push({
          x: "",
          y: 5,
          type: "zone",
          label: ``,
        });

        events.push({
          x: zoneName,
          y: 5,
          type: "zone",
          remarks: "pass",
          label: `Entered Zone: ${zoneName}`,
        });

        zoneSnapshot.child("Assembly Data").forEach((assemblySnapshot) => {
          const timestamp = new Date(assemblySnapshot.child("Timestamp").val()).getTime();
          events.push({
            x: assemblySnapshot.child("Station Code").val(),
            y: 5,
            type: "assembly",
            remarks: `STATUS: ${assemblySnapshot.child("Remarks").val()|| ""}`,
            timestamp: `crossed at ${assemblySnapshot.child("Timestamp").val() || ""}`,
            label: `made by ${assemblySnapshot.child("Operator Code").val() || ""}`,
          });

          array.push(createData(
            zoneName,
            assemblySnapshot.child("Station Code").val(),
            assemblySnapshot.child("Operator Code").val(),
            assemblySnapshot.child("Timestamp").val(),
            assemblySnapshot.child("Remarks").val(),
          ));

        });

      const offTrackTime = new Date(zoneSnapshot.child("Offtrack Time").val()).getTime();
        events.push({
          x: zoneName,
          y: 5,
          type: "zone",
          remarks: "pass",
          label: `Exited Zone: ${zoneName}`,
        });

        Data[zoneName] = array;
      });

      setTimelineData(events);
      setDataState(Data);
      setLDDataState(LDData);
      setOTDataState(OTData);
      setZoneDataState(zones);
      setLengthState(zones.length);
    });

    return () => {
      ref.off();
      ref2.off();
    };
  }, [value]);
  console.log(timelineData)
  //setValue("LMEZ411392")
  const handleNearestX = (value) => {
    setCrosshairValues([value]);
  };
  /*const formatLabel = (dataPoint) => {
    return `Station Code: ${dataPoint.stationCode}, Operator Code: ${dataPoint.operatorCode || ""}, Remarks: ${dataPoint.remarks}`;
  };*/
  return (
    <>
      <PageTitle title="Product History" />
      <Grid alignItems="center" container spacing={4} justifyContent="center">
        <Grid item xs={12}>
          <Autocomplete
            value={value}
            onChange={(event, newValue) => setValue(newValue)}
            id="controllable-states-demo"
            options={optionsState}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField {...params} label="Engine Number" variant="outlined" />
            )}
          />
        </Grid>
      </Grid>

      {timelineData.length > 0 && (
        <Grid container spacing={4}  justifyContent="center">
          <Grid item xs={12}>
            <Widget
              title={`Timeline for Engine Number: ${engineNumber} - Engine Model: ${engineModel}`}
              upperTitle
              titleAlign="center"
              bodyClass={classes.tableWidget}
            >
              <ResponsiveContainer width="100%" height={200}>
                <LineChart data={timelineData}>
                  <XAxis dataKey="x" hide/>
                  <YAxis type="category" dataKey="y" hide />
                  <Line
                    type="monotone"
                    dataKey="y"
                    stroke="#8884d8" // Default color
                    strokeWidth={5}
                  >
                    <LabelList dataKey="x" position="top" offset={25} angle={-90} />
                  </Line>
                  <Tooltip
                    contentStyle={{ backgroundColor: '#f5f5f5' }}
                    formatter={(value, name, props) => (
                      <div>
                        <div>{`${props.payload.remarks || ''}`}</div>
                        <div>{`${props.payload.label || ''}`}</div>
                        <div>{`${props.payload.timestamp || ''}`}</div>
                      </div>
                    )}
                  />
                </LineChart>
              </ResponsiveContainer>
            </Widget>
          </Grid>
          <Grid item xs={12}>
            <Widget
              title="Profile Summary"
              upperTitle
              bodyClass={classes.tableWidget}
            >
              <Grid container spacing={4} align="center" alignItems="center">
                <Grid item lg={4} md={6} sm={6} xs={8}>
                  <Typography size="md" weight="medium">
                    Engine Number: {engineNumber}
                  </Typography>
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={8}>
                  <Typography size="md" weight="medium">
                    Model: {engineModel}
                  </Typography>
                </Grid>
              </Grid>

              {lengthState > 0 && (
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography weight="medium" variant="h4">
                      ZONE: {zoneState[0]}
                    </Typography>
                    <Typography weight="medium">
                      Laydown: {LDState[0]}
                    </Typography>
                    <Typography weight="medium">
                      Offtrack: {OTState[0]}
                    </Typography>
                    <EngineBioTable data={dataState[zoneState[0]]} />
                  </Grid>
                </Grid>
              )}

              {lengthState > 1 && (
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography weight="medium" variant="h4">
                      ZONE: {zoneState[1]}
                    </Typography>
                    <Typography weight="medium">
                      Laydown: {LDState[1]}
                    </Typography>
                    <Typography size="s" weight="medium">
                      Offtrack: {OTState[1]}
                    </Typography>
                    <EngineBioTable data={dataState[zoneState[1]]} />
                  </Grid>
                </Grid>
              )}
            </Widget>
          </Grid>
        </Grid>
      )}
    </>
  );
}
